import React, { useState, useEffect } from "react";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // 监听页面滚动
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  // 滚动到页面顶部
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-4 right-4 bg-gray-800 hover:bg-main-color text-white font-bold py-2 px-4 rounded-full h-[56px]"
        >
          <svg
            t="1711618977862"
            className="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="6189"
            width="24"
            height="24"
          >
            <path
              d="M619.978011 959.52024H404.021989c-17.911044 0-32.23988 14.328836-32.23988 32.23988s14.328836 32.23988 32.23988 32.23988h216.467766c17.3993 0 32.23988-14.328836 32.23988-32.23988-0.511744-17.911044-14.84058-32.23988-32.751624-32.23988zM655.288356 870.988506H368.711644c-17.911044 0-32.23988 14.328836-32.23988 32.23988s14.328836 32.23988 32.23988 32.23988h286.576712c17.911044 0 32.23988-14.328836 32.23988-32.23988s-14.328836-32.23988-32.23988-32.23988zM685.993003 784.503748H338.006997c-17.911044 0-32.23988 14.328836-32.239881 32.23988s14.328836 32.23988 32.239881 32.23988h347.986006c17.911044 0 32.23988-14.328836 32.239881-32.23988s-14.84058-32.23988-32.239881-32.23988zM874.314843 214.42079L567.268366 15.352324c-32.23988-20.469765-79.32034-20.469765-111.56022 0.511744L149.685157 214.932534c-28.657671 18.422789-40.93953 48.615692-32.23988 78.808595 10.234883 34.286857 45.545227 57.827086 88.01999 57.827087h43.498251c17.3993 0 26.610695 8.69965 26.610695 11.770115v263.548226c0 64.47976 65.503248 117.189405 145.335332 117.189405h182.18091c44.521739 0 85.461269-15.864068 113.607196-44.009995 20.469765-20.981509 32.23988-47.08046 32.23988-73.691154V363.338331c0-3.070465 9.211394-11.770115 26.610695-11.770115h42.986507c42.474763 0 77.785107-23.028486 88.01999-57.827087 9.211394-30.192904-3.582209-60.385807-32.23988-79.320339z m-55.78011 72.667666h-42.986507c-51.174413 0-91.090455 33.263368-91.090455 76.249875v263.548226c0 28.145927-37.869065 53.221389-81.367316 53.221389H420.909545c-43.498251 0-81.367316-25.075462-81.367316-53.221389V363.338331c0-42.474763-39.916042-76.249875-91.090455-76.249875H204.953523c-15.864068 0-25.075462-7.164418-26.610694-11.770115-0.511744-2.558721 4.605697-6.14093 5.629185-6.652674l306.534733-199.068466c5.629185-3.582209 12.793603-5.629185 20.981509-5.629185 7.676162 0 15.352324 2.046977 20.981509 5.629185l307.046477 199.068466c0.511744 0.511744 6.652674 4.093953 5.629185 6.652674-1.023488 3.582209-9.211394 11.770115-26.610694 11.770115z"
              fill="#ffffff"
              p-id="6190"
            ></path>
          </svg>
        </button>
      )}
    </div>
  );
};

export default ScrollToTopButton;
